import { Pipe, PipeTransform } from '@angular/core';
import { BcmService } from '@modules/bcm/bcm.service';
import { Tenant } from '@shared/models/tenant';
import { BcmInvoiceTemplateSettings, BcmSettings, BcmSettingsSectionName } from '@shared/models/bcm-settings';
import { BcmSupportedCurrencyCodes } from '@modules/bcm/@shared/enums/supported-currencies';
import { BcmSettingsFacade } from '@bcmServices/settings/bcm-settings-facade';
import { InvoicePosition } from '@shared/models/invoice-position';
import { ProductService } from '@modules/bcm/products/product/product.service';
import { getTaxRateValue } from '@core/functions/get-tax-rate-value';

@Pipe({
    name: 'bcmDynamicGrossToNetPrice',
    standalone: false
})
export class DynamicGrossToNetPricePipe implements PipeTransform {

    tenant: Tenant;

    settings: BcmSettings;

    invoiceTemplateSettings: BcmInvoiceTemplateSettings;

    constructor(private bcmService: BcmService,
                private bcmSettingsFacade: BcmSettingsFacade,
                private productService: ProductService) {
        this.bcmService.selectedTenant$.subscribe(tenant => this.tenant = tenant);
        this.settings = this.bcmSettingsFacade.settings();
        this.invoiceTemplateSettings = this.settings ? this.settings[BcmSettingsSectionName.InvoiceTemplate] : {};
    }

    transform(position: InvoicePosition, total = false): number {
        switch (this.tenant?.currencyCode) {
            case BcmSupportedCurrencyCodes.CHF:
                if (this.invoiceTemplateSettings.showSinglePriceInNet) {
                    const taxRateValue = getTaxRateValue(position);
                    return this.productService.getNetPrice(position.price || position.product?.price, taxRateValue);
                }
                return position.price || position.product?.price;
            default:
                return position.price || position.product?.price;
        }
    }
}
